import { createContext } from "react"

const AuthState = createContext()

export default AuthState;